export default __webpack_public_path__ + "static/episode_2-bd79edec1ece694738200c2ee50b5eec.jpg";